
export default  [
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Informações de Cadastro',
    },
    {
        id: 1,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        field: 'cnpj',
        label: 'CNPJ',
        mask: 'cnpj',
        rules: ['required']
    },
    {
        id: 2,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-6',
        type: 'text',
        field: 'nome',
        maxlength: 255,
        label: 'Nome',
        rules: ['required']
    },
    {
        id: 3,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'email',
        field: 'email',
        maxlength: 100,
        label: 'Email',
        rules: ['required', 'email']
    },
    {
        id: 4,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        maxlength: 100,
        field: 'tel_com',
        label: 'Telefone',
        mask: 'telefone',
        rules: ['required']
    },
    {
        id: 5,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'cep',
        maxlength: 10,
        field: 'cep',
        label: 'CEP',
        mask: 'cep',
        rules: ['required']
    },
    {
        id: 6,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 500,
        field: 'end',
        label: 'Endereço',
        rules: ['required']
    },
    {
        id: 6,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        maxlength: 50,
        field: 'num',
        label: 'Número',
        rules: ['required']
    },
    {
        id: 7,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-2',
        type: 'text',
        maxlength: 100,
        field: 'bairro',
        label: 'Bairro',
        rules: ['required']
    },
    {
        id: 7,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        maxlength: 50,
        field: 'comp',
        label: 'Complemento',
        rules: ['required']
    },
    {
        id: 8,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'select-uf',
        field: 'id_estado',
        label: 'Estado',
        rules: ['required']
    },
    {
        id: 9,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'select-cidade',
        field: 'id_cidade',
        label: 'Cidade',
        rules: ['required']
    },
    {
        id: 14,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'textarea',
        field: 'obs',
        label: 'Observações',
        maxlength: 500,
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Representante Legal da Empresa',
    },
    {
        id: 10,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'r_nome',
        label: 'Nome',
        rules: ['required']
    },
    {
        id: 10,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'r_email',
        label: 'Email',
        rules: ['required']
    },
    {
        id: 10,
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'r_tel_com',
        label: 'Telefone',
        mask: 'celular',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12',
        type: 'group',
        icon: 'fa fa-arrow-circle-right',
        label: 'Alterar Minha Senha',
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'u_nome',
        label: 'Nome',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'u_cpf',
        label: 'Login',
        mask: 'cpf',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'text',
        field: 'u_email',
        label: 'Email',
        rules: ['required']
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'password',
        field: 'senha_atual',
        label: 'Senha Atual',
        rules: [],
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'password',
        field: 'senha_nova',
        label: 'Nova Senha (Mínimo 6 caracteres)',
        rules: [],
    },
    {
        class: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-4',
        type: 'password',
        field: 'senha_confirma',
        label: 'Confirmar Nova Senha',
        rules: [],
    },
]



// WEBPACK FOOTER //
// ./src/components/apps/credenciada/meu-cadastro/_form/meu-cadastro.js